import { useState } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';

interface AddItemRowProps {
  groupColor: string;
  onAddItem: (name: string) => void;
}

export function AddItemRow({ groupColor, onAddItem }: AddItemRowProps) {
  const [isAdding, setIsAdding] = useState(false);
  const [itemName, setItemName] = useState('');

  const handleSubmit = () => {
    if (itemName.trim()) {
      onAddItem(itemName.trim());
      setItemName('');
    }
    setIsAdding(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit();
    } else if (e.key === 'Escape') {
      setIsAdding(false);
      setItemName('');
    }
  };

  if (isAdding) {
    return (
      <div className="flex items-center border-b border-white/5 bg-white/5">
        <div className="min-w-[300px] flex items-center px-4 py-2 border-r border-white/5">
          <div
            className="w-1 h-5 rounded-full mr-3"
            style={{ backgroundColor: groupColor }}
          />
          <input
            type="text"
            value={itemName}
            onChange={(e) => setItemName(e.target.value)}
            onBlur={handleSubmit}
            onKeyDown={handleKeyDown}
            placeholder="+ Add item"
            className="flex-1 text-sm bg-transparent outline-none text-white placeholder-gray-500"
            autoFocus
          />
        </div>
        <div className="flex-1" />
      </div>
    );
  }

  return (
    <button
      onClick={() => setIsAdding(true)}
      className="w-full flex items-center px-4 py-2 text-sm text-gray-500 hover:text-gray-300 hover:bg-white/5 transition-colors"
    >
      <PlusIcon className="h-4 w-4 mr-2" />
      Add item
    </button>
  );
}
